import { createStyledContext } from "@tamagui/core";
const SwitchStyledContext = createStyledContext({
  size: void 0,
  unstyled: process.env.TAMAGUI_HEADLESS === "1"
});
export { SwitchStyledContext };